module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-BELLINI-BLISS.8301f21.8301f21.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-BELLINI-BLISS.8301f21.gif
// module id = NcIO
// module chunks = 0